/**
 * @fileoverview Module for `src/admin/authProvider.js`.
 */

/**
 * Builds a React Admin auth provider around the app's auth context.
 *
 * Using the context's auth rather than a separate instance means logout clears the app's React Query
 * cache, and the provider shares session state with the Admin pages, which read the same instance
 * through `AuthContext`.
 *
 * @param {Object} auth - Auth API from `AuthContext`.
 * @returns {Object} React Admin auth provider.
 */
function createAuthProvider(auth) {
  return {
    login: () => {
      auth.login();
      return Promise.resolve();
    },
    logout: () => {
      auth.logout();
      return Promise.resolve();
    },
    checkError: () => Promise.resolve(),
    checkAuth: () => Promise.resolve(),
    getPermissions: () => Promise.resolve(auth.getGrants()),
  };
}

export default createAuthProvider;
